// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__33JLz","footerContainer":"Footer_footerContainer__1f7B4","footerTop":"Footer_footerTop__3xNcD","footerBottom":"Footer_footerBottom__18CRW"};